import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { ICcyPairPromiseLookupService } from "../ICcyPairPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class CcyPairPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.CurrencyPairImpl>
  implements ICcyPairPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getCcyPair(base: string, nonBase: string): Promise<CubiqTS.CurrencyPairImpl>;
  abstract getVehicleCurrencies(base: string, nonBase: string): Promise<Array<any>>;
}
